/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CargoUnitDto } from '../model'
// @ts-ignore
import type { ContainerHistoryAdditionalDataDto } from '../model'
/**
 * CargoUnitsApi - axios parameter creator
 */
export const CargoUnitsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} [cargoUnitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAvailableEmpties: async (
      cargoUnitId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/CargoUnits/getAvailableEmpties`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (cargoUnitId !== undefined) {
        localVarQueryParameter['CargoUnitId'] = cargoUnitId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {Array<number>} [gangIds]
     * @param {Array<number>} [shiftIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContainerHistoryAdditionalData: async (
      gangIds?: Array<number>,
      shiftIds?: Array<number>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/CargoUnits/GetContainerHistoryAdditionalData`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (gangIds) {
        localVarQueryParameter['GangIds'] = gangIds
      }

      if (shiftIds) {
        localVarQueryParameter['ShiftIds'] = shiftIds
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {object} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOnTerminal: async (
      query?: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/CargoUnits/getOnTerminal`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (query !== undefined) {
        for (const [key, value] of Object.entries(query)) {
          localVarQueryParameter[key] = value
        }
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {object} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReefersOnTerminal: async (
      query?: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/CargoUnits/getReefersOnTerminal`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (query !== undefined) {
        for (const [key, value] of Object.entries(query)) {
          localVarQueryParameter[key] = value
        }
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CargoUnitsApi - functional programming interface
 */
export const CargoUnitsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CargoUnitsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {number} [cargoUnitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAvailableEmpties(
      cargoUnitId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CargoUnitDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableEmpties(
        cargoUnitId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CargoUnitsApi.getAvailableEmpties']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {Array<number>} [gangIds]
     * @param {Array<number>} [shiftIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getContainerHistoryAdditionalData(
      gangIds?: Array<number>,
      shiftIds?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerHistoryAdditionalDataDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getContainerHistoryAdditionalData(
        gangIds,
        shiftIds,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CargoUnitsApi.getContainerHistoryAdditionalData']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {object} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOnTerminal(
      query?: object,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CargoUnitDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOnTerminal(query, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CargoUnitsApi.getOnTerminal']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {object} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReefersOnTerminal(
      query?: object,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CargoUnitDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getReefersOnTerminal(query, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CargoUnitsApi.getReefersOnTerminal']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * CargoUnitsApi - factory interface
 */
export const CargoUnitsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CargoUnitsApiFp(configuration)
  return {
    /**
     *
     * @param {number} [cargoUnitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAvailableEmpties(
      cargoUnitId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CargoUnitDto>> {
      return localVarFp
        .getAvailableEmpties(cargoUnitId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {Array<number>} [gangIds]
     * @param {Array<number>} [shiftIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContainerHistoryAdditionalData(
      gangIds?: Array<number>,
      shiftIds?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ContainerHistoryAdditionalDataDto> {
      return localVarFp
        .getContainerHistoryAdditionalData(gangIds, shiftIds, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {object} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOnTerminal(
      query?: object,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CargoUnitDto>> {
      return localVarFp.getOnTerminal(query, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {object} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReefersOnTerminal(
      query?: object,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CargoUnitDto>> {
      return localVarFp
        .getReefersOnTerminal(query, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * CargoUnitsApi - object-oriented interface
 */
export class CargoUnitsApi extends BaseAPI {
  /**
   *
   * @param {number} [cargoUnitId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getAvailableEmpties(cargoUnitId?: number, options?: RawAxiosRequestConfig) {
    return CargoUnitsApiFp(this.configuration)
      .getAvailableEmpties(cargoUnitId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {Array<number>} [gangIds]
   * @param {Array<number>} [shiftIds]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getContainerHistoryAdditionalData(
    gangIds?: Array<number>,
    shiftIds?: Array<number>,
    options?: RawAxiosRequestConfig,
  ) {
    return CargoUnitsApiFp(this.configuration)
      .getContainerHistoryAdditionalData(gangIds, shiftIds, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {object} [query]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getOnTerminal(query?: object, options?: RawAxiosRequestConfig) {
    return CargoUnitsApiFp(this.configuration)
      .getOnTerminal(query, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {object} [query]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getReefersOnTerminal(query?: object, options?: RawAxiosRequestConfig) {
    return CargoUnitsApiFp(this.configuration)
      .getReefersOnTerminal(query, options)
      .then(request => request(this.axios, this.basePath))
  }
}
